import { render, staticRenderFns } from "./sales-incentive.vue?vue&type=template&id=a66fe670&scoped=true&"
import script from "./sales-incentive.vue?vue&type=script&lang=js&"
export * from "./sales-incentive.vue?vue&type=script&lang=js&"
import style0 from "./sales-incentive.vue?vue&type=style&index=0&id=a66fe670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66fe670",
  null
  
)

export default component.exports